import Button from 'components/atoms/Button';
import OnOffButton from 'components/atoms/OnOffButton';
import Table from 'components/atoms/Table';
import { useDeleteLayer, useLayers, usePatchPublish } from 'hooks/RQuery/utils/layers';
import { useEffect, useState } from 'react';
import { transFormatDate } from 'util/scripts';

const LayerList = () => {
  const [layerType, setLayerType] = useState<'CTRL_POINT' | 'ETC'>('CTRL_POINT');
  const [list, setList] = useState([]);
  const layerList = useLayers({ layerType });
  const patchLayer = usePatchPublish();
  const deleteLayer = useDeleteLayer();
  useEffect(() => {
    if (layerList.data) {
      setList(layerList.data);
    }
  }, [layerList.data]);

  const onPublish = (layerId: string) => {
    if (window.confirm('레이어를 활성화하시겠습니까?')) {
      patchLayer.mutate(
        { layerId },
        {
          onSuccess: () => {
            alert('활성화 완료');
          },
        },
      );
    }
  };
  const onDelete = (layerId: string) => {
    if (window.confirm('레이어를 삭제하시겠습니까?')) {
      deleteLayer.mutate(
        { layerId },
        {
          onSuccess: () => {
            alert('삭제 완료');
          },
        },
      );
    }
  };
  return (
    <>
      <input type="radio" id="CTRL_POINT" name={'type'} onChange={() => setLayerType('CTRL_POINT')} checked={layerType === 'CTRL_POINT'} />
      <label htmlFor="CTRL_POINT" style={{ marginRight: 20 }}>
        도근점
      </label>
      <input type="radio" id="ETC" name={'type'} onChange={() => setLayerType('ETC')} checked={layerType === 'ETC'} />
      <label htmlFor="ETC">기타</label>
      <Table
        caption="레이어 목록"
        colgroup={[120, 'auto', 60, 120, 180]}
        thead={
          <tr>
            <th scope="col">타입</th>
            <th scope="col">레이어명</th>
            <th scope="col">좌표계</th>
            <th scope="col">생성일</th>
            <th scope="col">활성화</th>
          </tr>
        }
        tbody={
          <>
            {list.map((i: any) => {
              return (
                <tr key={i.layerId}>
                  <td>{i.type === 'CTRL_POINT' ? '도근점' : i.type === 'TRI_POINT' ? '삼각점' : i.type === 'AUX_TRI_POINT' ? '삼각보조점' : '기타'}</td>
                  <td>{i.name}</td>
                  <td>{i.srid}</td>
                  <td>{transFormatDate(i.createdDate, '-')}</td>
                  <td>
                    {i.isPublished ? (
                      '활성화됨'
                    ) : (
                      <div style={{ display: 'flex', gap: 4, justifyContent: 'center' }}>
                        <Button text="활성화" $colorType="peacock" width={80} height={28} onClick={() => onPublish(i.layerId)} />
                        <Button text="삭제" $colorType="white" width={80} height={28} onClick={() => onDelete(i.layerId)} />
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
          </>
        }
      />
    </>
  );
};

export default LayerList;
